var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { default as bemCssModules } from 'bem-css-modules';
import { getApiClient } from '../../../api/ClientProvider';
import { default as NotifyFormStyle } from './NotifyForm.module.css';
import { NotifyTypeEnum } from '../helpers/NotifyTypeEnum';
import { TokenProvider } from '../../../api/helpers/TokenProvider';
import { useTranslationByKey } from '../../../helpers/useTranslationByKeys';
import React, { useCallback, useState } from 'react';
const REGEX_EMAIL = /^(([^<>()\],;:\s@]+(\.[^<>()[\].,;:\s@]+)*)|(.+))@(([^<>()[\],;:\s@]+\.)+[^<>()[\],;:\s@]{2,})$/i;
const style = bemCssModules(NotifyFormStyle);
export const NotifyForm = (props) => {
    const t = useTranslationByKey();
    const { currentType, inputData, handleOnSubmit, handleOnChange, productCode, } = props;
    const [isActiveInput, toggleActiveInput] = useState(false);
    const isEmail = NotifyTypeEnum.email === currentType;
    const client = getApiClient();
    const isCorrectInputData = isEmail
        ? REGEX_EMAIL.test(inputData)
        : !!inputData.length;
    const newsletterFormClassName = () => {
        if (isActiveInput) {
            return isCorrectInputData ? style(null, { 'is-valid': true }) : style();
        }
        if (inputData.length) {
            return isCorrectInputData
                ? style(null, { 'is-valid': true })
                : style(null, { 'is-invalid': true });
        }
        return style();
    };
    const handleOnFocus = useCallback(() => {
        toggleActiveInput(!isActiveInput);
    }, [isActiveInput]);
    const handleOnClick = useCallback((event) => __awaiter(void 0, void 0, void 0, function* () {
        event.preventDefault();
        if (!isCorrectInputData) {
            return;
        }
        const customerId = yield TokenProvider.getCustomerId();
        yield client.createBackInStockNotificationSubscription({
            body: {
                customerId: Number(customerId),
                notificationChannel: isEmail ? 'Email' : 'Sms',
                itemCode: productCode,
                [isEmail ? 'email' : 'telephoneNumber']: inputData,
            },
        });
        handleOnSubmit();
    }), [
        client,
        handleOnSubmit,
        inputData,
        isCorrectInputData,
        isEmail,
        productCode,
    ]);
    return (React.createElement("div", { className: newsletterFormClassName() },
        React.createElement("form", { className: style('form') },
            React.createElement("div", { className: `${style('form-field')} ori-icon ori-icon--round-exclam` },
                React.createElement("label", { className: style('input-label') }, isEmail
                    ? t('Enter your email below to be notified when this item is back on stock.')
                    : t('Enter telephone number')),
                React.createElement("input", { className: style('input-field'), onBlur: handleOnFocus, onChange: handleOnChange, onFocus: handleOnFocus, type: "text", value: inputData }),
                React.createElement("button", { className: `${style('button')} ori-icon ori-icon--${isCorrectInputData ? 'send-filled' : 'send'}`, onClick: handleOnClick, type: "submit" })),
            React.createElement("p", { className: style('validate-info') }, t('E-mail address is not valid.')))));
};
